module.exports = __webpack_public_path__ + "img/Review2.6bce9687.png";